import React from 'react';

/** Status options shown in the Create Care modal (mirrors CRM 1.0 careStateOptions). */
export const CARE_STATUS_OPTIONS: { value: number; labelKey: string }[] = [
  { value: 3, labelKey: 'pflege.cares.status_options.3' },
  { value: 0, labelKey: 'pflege.cares.status_options.0' },
  { value: 2, labelKey: 'pflege.cares.status_options.2' },
  { value: 1, labelKey: 'pflege.cares.status_options.1' },
];

export const STATUS_KEY: Record<number, string> = {
  0: 'pflege.cares.status.new',
  1: 'pflege.cares.status.cancelled',
  2: 'pflege.cares.status.confirmed',
  3: 'pflege.cares.status.running',
  4: 'pflege.cares.status.completed',
};

export const cellStyle: React.CSSProperties = { padding: '13px 16px', verticalAlign: 'middle' };
